var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"draggableContainer",staticClass:"draggable-container",attrs:{"draggable":"true"},on:{"mousedown":_vm.dragStart,"mouseup":_vm.dragEnd,"mousemove":_vm.drag}},[_vm._t("default",function(){return [_c('div',{staticClass:"draggable-container__default"},[_vm._v("\n      Default draggable object.\n    ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }